module.exports = __webpack_public_path__ + "img/机器换人.79c35b34.png";